// ---------------------------------------------------------------------------
// Happy Fig — Event configuration (client / display copy)
// ---------------------------------------------------------------------------
// This file holds the *display* data for ticketed events. Adding a new supper
// club or pop-up is as simple as adding another entry to the EVENTS object and
// mirroring its id + pricing + capacity in `api/_lib/events.js` (server side,
// which is the source of truth for money and availability).
//
// Nothing secret lives here — it is safe to ship to the browser.
// ---------------------------------------------------------------------------

export const EVENTS = {
  "walled-garden-supper-club": {
    id: "walled-garden-supper-club",
    slug: "walled-garden-supper-club",
    title: "The Walled Garden Supper Club",
    tagline: "Hosted by Happy Fig at Carreglwyd Estate",
    dateLabel: "Tuesday 18 August 2026",
    // Price shown to the customer. The actual charge is calculated server-side
    // from `api/_lib/events.js` so it can never be tampered with in the browser.
    priceLabel: "£50 per guest",
    priceGBP: 50,

    // Each sitting has its OWN capacity and sells out independently.
    sittings: [
      { id: "530", label: "Early sitting", time: "5:30pm – 7:00pm" },
      { id: "830", label: "Late sitting", time: "8:30pm – 10:00pm" },
    ],

    description: [
      "Join us for an evening of locally sourced, seasonal cooking served within the beautiful surroundings of the walled garden at Carreglwyd Estate.",
      "Expect a relaxed, convivial supper of sharing-style plates built around the very best produce North Wales has to offer that week — cooked by Harri & Meg and their team, and served under the evening sky.",
    ],

    // A sample menu — the final menu is shaped by what's at its best on the day.
    menu: {
      note: "Served sharing-style. Dishes may flex a little with the best produce on the day.",
      courses: [
        {
          name: "Starter",
          items: [
            "Pan con tomate — toasted bread with ripe tomatoes, extra virgin olive oil & anchovy",
          ],
        },
        {
          name: "Sharing main",
          items: [
            "Warm wild trout with brown butter, lemon & pangrattato",
            "Charred aubergine with herbs & toasted walnuts",
            "Heritage tomato & basil salad",
            "Tatys Bryn new potatoes with lemon & olive oil",
            "Peach, rocket, sheep's cheese & toasted hazelnuts",
          ],
        },
        {
          name: "Dessert",
          items: ["Lemon brûlée"],
        },
      ],
    },

    venue: {
      name: "Carreglwyd Estate",
      details: [
        "The supper club is held in the walled garden at Carreglwyd Estate, Anglesey.",
        "The evening takes place largely outdoors — please dress for a Welsh summer evening and bring a layer in case it turns cool after sunset.",
      ],
    },

    parking: [
      "Free on-site parking is available at the estate.",
      "Please arrive 15 minutes before your sitting to allow time to park and be seated.",
    ],

    // Arrival guidance included in the confirmation email.
    arrival:
      "Please arrive 15 minutes before your chosen sitting. Follow signs for the walled garden on arrival at Carreglwyd Estate, where a member of the Happy Fig team will welcome you.",

    // Points the customer must actively confirm before paying.
    terms: [
      "I have selected the correct sitting for my booking.",
      "The dietary requirements and allergy information I have provided are accurate.",
      "I have read and agree to the Happy Fig Terms & Conditions.",
    ],
    termsUrl: "/Happy Fig Terms and Conditions (2025).pdf",

    // Largest party a single booking can request (keeps the form + Stripe
    // metadata sensible; larger groups can make two bookings or get in touch).
    maxPartySize: 10,
  },
};

// The event featured on the homepage button.
export const FEATURED_EVENT_ID = "walled-garden-supper-club";

export const getEvent = (id) => EVENTS[id];
export const getFeaturedEvent = () => EVENTS[FEATURED_EVENT_ID];
